import Vue from 'vue'
import Vuex from 'vuex'

import pageDesign from './modules/pageDesign'

Vue.use(Vuex)

const modules = { pageDesign }


const store = new Vuex.Store({
  modules,
  state: {
    appId: Number(localStorage.getItem('appId')) || 0,
    weimeng: {
      code: 0,
      data: {
        avatarUrl: ""
      }
    }
  },
  mutations: {
    setAppId(state, id) {
      state.appId = id
      localStorage.setItem('appId', id)
    },
    setWeiMeng(state, data) {
      state.weimeng = data
    }
  },
})

export default store
